import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import OverviewSplineGraph from './OverviewSplineGraph'
import NothingToShow from './NothingToShow'

const CaptableManagementList = ({ title, data }: { title: string; data: any }) => {
  const { formatMessage } = useIntl()
  return (
    <Card className='w-100 bg-white'>
      <div>
        <p className='text-muted p-4'>{formatMessage({ id: title })}</p>
        {/* <OverviewSplineGraph /> */}
        {data && data.length > 0 ?
          <OverviewSplineGraph />
          :
          null}
        <div className='px-4 pb-4'>
          {data && data.length > 0 ?
            data.map((item: any, index: any) => (
              <CaptableManagementListItem
                key={index} // Use a unique key, preferably `item.id` if available
                invName={item.legalName || `${item.firstName} ${item.lastName}`} // Use legalName or fullName
                invPercent={item.percentage.toFixed(2)} // Format percentage to 2 decimal places
                badgecolor='#50CD89' // Use consistent colors or derive from item
                badgebg='#E8FFF3'
              />
            ))
            :
            <div className='d-flex align-items-center justify-content-center'>
              {/* <p>{formatMessage({ id: 'Nothing to Show' })}</p> */}
              <NothingToShow />
            </div>
          }
        </div>
      </div>
    </Card>
  )
}

const CaptableManagementListItem = ({ badgecolor, badgebg, invName, invPercent }: any) => {
  return (
    <>
      <div className='d-flex flex-row align-items-center mt-5'>
        <div className='d-flex w-100 gap-2'>
          <span>
            <img
              src={toAbsoluteUrl('/media/icons/duotune/general/more_user.svg')}
              alt='profilepic'
              height='24px'
              width='24px'
            />
          </span>
          <div className='d-flex align-items-center justify-content-between w-100'>
            <h1 className='m-0 font-size-13 fw-semibold'>{invName}</h1>
            <div
              className='p-1'
              style={{
                background: badgebg,
                padding: ' 4px 8px 4px 8px',
                borderRadius: '4px',
                color: badgecolor,
              }}
            >
              {invPercent}%
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CaptableManagementList
